// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"src-modules-searchResults---searchResults"};